const initialState = {
  addDays: 0,
};
const initialStateForTest = {
  addDays: 0,
};

export default initialState;
export { initialStateForTest };
